<template>
	<page-layout class="contacts-page" title="Nyheder">
		<table-view :columns="columns" :items="$store.state.news" @item="itemClick" :dot="true" />
	</page-layout>
</template>

<script>
	import PageLayout from '@/app/layouts/PageLayout'
	import SelectPopupView from '@/components/SelectPopupView'

	export default {
		components: {
			pageLayout: PageLayout
		},
		data() {
			return {
				columns: [
					{
						data: ['created'],
						label: 'Dato',
						filter: 'date',
						weight: '100px',
					},
					{
						data: ['title'],
						label: 'Titel',
					}
				],
			};
		},
		methods: {
			create() {
				var self = this;

			},
			async itemClick(item) {
				console.log('click', item);

				new Promise(async (resolve) => {
					await this.axios.put(`/news/${item.id}/read/`);
					this.update();
					resolve();
				});

				var self = this;
				var options = [
					{
						label: item.content?.replace(/\n/g, '<br>') || '',
						type: 'text',
						/*callback: function () {
							window.location = 'tel:' + item.phone;
							self.$store.commit('popPopup');
						}*/
					}
				];

				for (const file of item._embedded?.files || []) {
					options.push({
						label: file.label,
						callback: function () {
							console.log('open file', file);

							self.axios
								.get('/storage/urls/' + file.id + '/')
								.then(function (r) {
									const url = r.data.replace('storage.moovr.dk', 'mobile.moovr.dk/files');

									//window.open(url, '_blank');
									window.location.href = r.data;

									
								});
						}
					});
				}

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: item.title,
						options: options,
						actions: [
							{
								label: 'Luk',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			},
			itemDelete(item) {
				var self = this;

				this.axios.delete('/portal/users/' + item.id + '/').then(function () {
					self.update();
				});
			},
			update() {
				this.$store.dispatch('updateNews');
			}
		},
		mounted() {
			this.update();
		}
	}
</script>
